import types from "../actions";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SET_TRACKS:
      let newState = { ...state };
      action.payload.forEach(track => {
        const { id, ...rest } = track;
        if (!newState[id]) newState = { ...newState, [id]: rest };
      })
      return newState;
    default:
      return state;
  }
}
